"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _ToggleModule = _interopRequireDefault(require("./Toggle.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Note:
 * Do not wrap Toggle in a label. For simplicity's sake, Toggle uses an
 * internal label tag to handle click delegation to the hidden input, and
 * nesting labels is a bad idea.
 */

const Toggle = exports.Toggle = /*#__PURE__*/React.forwardRef((_ref, forwardRef) => {
  let {
    name = 'toggle',
    value = '',
    classNames,
    children,
    disabled,
    checked,
    focused,
    onChange,
    ariaLabel,
    labelPosition = 'right',
    testId,
    ...props
  } = _ref;
  const toggleInput = /*#__PURE__*/React.createRef();
  React.useImperativeHandle(forwardRef, () => toggleInput.current);
  const handleOnChange = () => {
    if (!disabled) {
      onChange?.({
        value,
        checked: !checked
      });
    }
  };
  const onWrapClickHandler = e => {
    e.nativeEvent.stopImmediatePropagation();
    toggleInput.current?.click();
  };
  React.useEffect(() => {
    if (toggleInput.current && focused) {
      toggleInput.current.focus();
    }
  }, [focused]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'toggle'
    }),
    className: (0, _classify.default)(_ToggleModule.default.container, {
      [_ToggleModule.default.disabled]: disabled
    }, classNames?.wrapper),
    onClick: onWrapClickHandler,
    children: [labelPosition === 'left' && React.Children.count(children) > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'label'
      }),
      className: (0, _classify.default)(_ToggleModule.default.toggleLabel, classNames?.label),
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: _ToggleModule.default.toggleWrap,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        type: "checkbox",
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'input'
        }),
        name: name,
        value: value,
        checked: checked,
        onChange: handleOnChange,
        ref: toggleInput,
        disabled: disabled,
        "aria-label": ariaLabel || children,
        ...props
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classify.default)(_ToggleModule.default.toggle, {
          [_ToggleModule.default.disabledButton]: disabled
        })
      })]
    }), labelPosition === 'right' && React.Children.count(children) > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'label'
      }),
      className: (0, _classify.default)(_ToggleModule.default.toggleLabel, classNames?.label),
      children: children
    })]
  });
});
Toggle.displayName = 'Toggle';